<ng-select [(ngModel)]="cityValue" (change)="cityChanged()" placeholder="{{'trainings.label.cities' | translate}}" [closeOnSelect]="true"
  [searchable]="false" [selectOnTab]="true" appendTo="body" class="filters__dropdown dropdown--small dropdown--border">
  <ng-option *ngFor="let option of cities" [value]="option.externalId">{{option.name | splitCamelCase}}</ng-option>
</ng-select>